import { render, staticRenderFns } from "./BusinessTracking.vue?vue&type=template&id=349ca084"
import script from "./BusinessTracking.vue?vue&type=script&lang=js"
export * from "./BusinessTracking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports